import { useState } from 'react';
import { contentGroups } from '@/mocks/haijiao';

export default function Categories() {
  const [active, setActive] = useState(0);
  const group = contentGroups[active];

  return (
    <section id="categories" className="border-b border-stone-200/80 bg-white">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-orange-600">
              <i className="ri-apps-2-fill"></i> 讨论区内容分类
            </p>
            <h2 className="mt-2 text-xl font-bold tracking-tight text-stone-900 md:text-2xl">
              按圈子分类浏览，对味的话题都在同一个小天地
            </h2>
          </div>
          <a
            href="#flow"
            className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-stone-200 px-3 py-1.5 text-xs text-stone-600 transition-colors hover:border-orange-400 hover:text-orange-700"
          >
            看看圈子精选 <i className="ri-arrow-right-s-line text-sm"></i>
          </a>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-[220px_1fr]">
          <div className="flex gap-2 overflow-x-auto lg:flex-col lg:overflow-visible">
            {contentGroups.map((g, i) => (
              <button
                key={g.group}
                onClick={() => setActive(i)}
                className={`flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-xl px-4 py-3 text-sm font-medium transition-colors lg:justify-start ${
                  i === active
                    ? 'bg-orange-600 text-white'
                    : 'border border-stone-200 bg-[#fdfaf6] text-stone-600 hover:border-orange-300'
                }`}
              >
                <i className={g.icon}></i> {g.group}
                <span className={`ml-auto hidden text-xs lg:inline ${i === active ? 'text-orange-100' : 'text-stone-400'}`}>
                  {g.items.length} 圈子
                </span>
              </button>
            ))}
          </div>

          <div className="rounded-2xl border border-stone-200 bg-[#fdfaf6] p-4 md:p-5">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-orange-600 text-white">
                <i className={group.icon}></i>
              </span>
              <h3 className="text-sm font-bold text-stone-900">{group.group} · 分类圈子</h3>
            </div>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
              {group.items.map((it) => (
                <a
                  key={it.name}
                  href="#flow"
                  className="flex items-center gap-3 rounded-xl border border-stone-200 bg-white p-3 transition-colors hover:border-orange-300 hover:bg-orange-50/50"
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-orange-100 text-orange-700">
                    <i className="ri-price-tag-3-line text-lg"></i>
                  </span>
                  <div className="min-w-0">
                    <p className="truncate text-sm font-semibold text-stone-900">{it.name}</p>
                    <p className="truncate text-xs text-stone-400">
                      {it.desc} · {it.count}人
                    </p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}